import { FASTElement as l, observable as n } from "@microsoft/fast-element";
import { sidebarStyles as p } from "./sidebar.styles.js";
import { sidebarTemplate as I } from "./sidebar.template.js";
var h = Object.defineProperty, f = (v, e, t, r) => {
  for (var s = void 0, i = v.length - 1, o; i >= 0; i--)
    (o = v[i]) && (s = o(e, t, s) || s);
  return s && h(e, t, s), s;
};
const m = class m extends l {
  constructor() {
    super(...arguments), this.navItems = [], this.bottomNavItems = [];
  }
  navItemsChanged() {
    this.resetNavItems(this.navItems);
  }
  bottomNavItemsChanged() {
    this.resetNavItems(this.bottomNavItems);
  }
  toggleNavItems(e) {
    e.eventTarget().active || this.navItems.map((t) => {
      t != e.eventTarget() && (t.active = !1);
    });
  }
  resetNavItems(e) {
    if (e.filter((t) => t.active).length > 1) {
      let t = !1;
      e.map((r) => {
        r.active && !t ? t = !0 : r.active = !1;
      });
    }
  }
};
m.definition = {
  name: "sidebar",
  template: () => I,
  styles: () => p
};
let a = m;
f([
  n
], a.prototype, "navItems");
f([
  n
], a.prototype, "bottomNavItems");
export {
  a as Sidebar
};
